import { createTheme } from "@mui/material/styles";
import { BRAND_COLORS } from "./utils/brandAssets";

export const colors = {
  background: "#0a0a0a",
  paper: "#141414",
  textPrimary: "#e4e4e7",
  textSecondary: "#71717a",
  border: "rgba(255, 255, 255, 0.06)",
  positive: "#22c55e",
  negative: "#ef4444",
};

export const chartColors = [
  "#22c55e",
  BRAND_COLORS.cyan,
  "#a855f7",
  "#f59e0b",
  "#ef4444",
  "#06b6d4",
  "#ec4899",
  "#84cc16",
];

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: BRAND_COLORS.cyan,
      contrastText: BRAND_COLORS.navy,
    },
    secondary: {
      main: "#ef4444",
      light: "#f87171",
      dark: "#dc2626",
    },
    success: {
      main: colors.positive,
    },
    error: {
      main: colors.negative,
    },
    warning: {
      main: "#f59e0b",
    },
    background: {
      default: colors.background,
      paper: colors.paper,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
    },
    divider: colors.border,
    action: {
      hover: "rgba(255, 255, 255, 0.06)",
      selected: "rgba(255, 255, 255, 0.1)",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: colors.background,
          color: colors.textPrimary,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: colors.paper,
          border: `1px solid ${colors.border}`,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: colors.paper,
          backgroundImage: "none",
          border: `1px solid ${colors.border}`,
          boxShadow: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: colors.background,
          borderRight: `1px solid ${colors.border}`,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.paper,
          backgroundImage: "none",
          borderBottom: `1px solid ${colors.border}`,
          boxShadow: "none",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          border: `1px solid ${colors.border}`,
          backgroundColor: colors.paper,
          "& .MuiDataGrid-cell": {
            borderBottom: `1px solid ${colors.border}`,
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.background,
            borderBottom: `1px solid ${colors.border}`,
          },
          "& .MuiDataGrid-columnSeparator": {
            color: colors.border,
          },
        },
      },
    },
  },
  typography: {
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 500 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 400 },
  },
});

export default theme;
